export default {"src":"/_next/static/media/brighter_ai.93f86bd7.svg","height":48,"width":160,"blurWidth":0,"blurHeight":0};